import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const PromptsIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.75 3.75h10.5A2.25 2.25 0 0119.5 6v8.25A2.25 2.25 0 0117.25 16.5H12l-4.5 3v-3H6.75A2.25 2.25 0 014.5 14.25V6A2.25 2.25 0 016.75 3.75z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8.25 7.5h7.5M8.25 10.5h5.25"
      />
    </>
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      fill="none"
      strokeWidth={1.5}
    />
  );
};

export default PromptsIcon;
